"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _store = require("../@api/store");
var _functions = require("../@functions");
var _firebase = _interopRequireDefault(require("../@api/appcenter/firebase.config"));
var _useInterval = _interopRequireDefault(require("./useInterval"));
var _useAsyncEffect = _interopRequireDefault(require("./useAsyncEffect"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var appcenterFirestore = _firebase["default"].firestore();
var domainCollection = appcenterFirestore.collection('portalDomains');
var companyCollection = appcenterFirestore.collection('company');
var licenseCollection = appcenterFirestore.collection('license');
function useWorkfluxPortal() {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    storeState = _useState2[0],
    setStoreState = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    portalDomain = _useState4[0],
    setPortalDomain = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    workfluxPortal = _useState6[0],
    setWorkfluxPortal = _useState6[1];
  var _useState7 = (0, _react.useState)({}),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    workfluxPortalLicense = _useState8[0],
    setWorkfluxPortalLicense = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    loading = _useState10[0],
    setLoading = _useState10[1];
  var domain = window.location.hostname;
  var _ref = storeState || {},
    auth = _ref.appcenter;
  (0, _useInterval["default"])(function () {
    var state = _store.store.getState();
    if (JSON.stringify(state) !== JSON.stringify(storeState)) {
      setStoreState(state);
    }
  }, '1s');
  (0, _useAsyncEffect["default"])( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var query, _yield$query$get, docs, domainDoc, workfluxPortalDomain, companyUid, companyDoc, company, _yield$query$get2, licenseDocs, licenses, _workfluxPortalLicense, paidOrFreeLicense;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (auth !== null && auth !== void 0 && auth.isAuthContextCreated) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          _context.prev = 2;
          setLoading(true);
          query = domainCollection.where('selected', '==', true).where('deleted', '==', false);
          if ((0, _functions.isLocal)()) {
            query = query.where('uid', '==', 'DmN-ig0JUj91HJNlnSS030');
          } else {
            query = query.where('domain', '==', domain);
          }
          _context.next = 8;
          return query.get();
        case 8:
          _yield$query$get = _context.sent;
          docs = _yield$query$get.docs;
          domainDoc = docs[0];
          workfluxPortalDomain = (domainDoc === null || domainDoc === void 0 ? void 0 : domainDoc.data()) || undefined;
          console.log('workfluxPortalDomain', workfluxPortalDomain);
          console.log('auth', auth);
          companyUid = workfluxPortalDomain === null || workfluxPortalDomain === void 0 ? void 0 : workfluxPortalDomain.company;
          if (companyUid) {
            _context.next = 17;
            break;
          }
          return _context.abrupt("return");
        case 17:
          _context.next = 19;
          return companyCollection.doc(companyUid).get();
        case 19:
          companyDoc = _context.sent;
          company = companyDoc.data();
          query = licenseCollection.where('company', '==', companyUid).where('type', '==', 'wokflux-portal').where('deleted', '==', false);
          _context.next = 24;
          return query.get();
        case 24:
          _yield$query$get2 = _context.sent;
          licenseDocs = _yield$query$get2.docs;
          licenses = licenseDocs.map(function (doc) {
            return doc.data();
          });
          _workfluxPortalLicense = licenses[0] || undefined;
          if (!!workfluxPortalDomain) {
            paidOrFreeLicense = licenses.find(function (license) {
              return ['paid', 'free'].includes(license.status);
            });
            if (paidOrFreeLicense) _workfluxPortalLicense = paidOrFreeLicense;
          }
          setPortalDomain(workfluxPortalDomain || {});
          setWorkfluxPortalLicense(_workfluxPortalLicense);
          setWorkfluxPortal(_objectSpread({}, company.portal || {}));
          _context.next = 38;
          break;
        case 34:
          _context.prev = 34;
          _context.t0 = _context["catch"](2);
          console.log('>=> >=>  PORTAL ERROR  <=< <=<');
          console.log('error: >=>', _context.t0);
        case 38:
          _context.prev = 38;
          setLoading(false);
          return _context.finish(38);
        case 41:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 34, 38, 41]]);
  })), [storeState, auth, domain]);
  return {
    loading: loading,
    workfluxPortal: workfluxPortal,
    workfluxPortalLicense: workfluxPortalLicense,
    portalDomain: portalDomain
  };
}
var _default = useWorkfluxPortal;
exports["default"] = _default;